// QrCode.tsx
import * as React from 'react'
import { QRCodeCanvas } from 'qrcode.react'

// Option 1: Use the Props type directly from the imported module
type QRCodeProps = Parameters<typeof QRCodeCanvas>[0]

export const QrCode = (props: QRCodeProps) => {
  const marginSize = 1
  return <QRCodeCanvas {...{size: 256, marginSize, ...props}} />
}
